import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import Service from '../Service';
import { RequestParamsPasswordRecovery, ResponseErrorBody } from '../../types';

export default async function(params: RequestParamsPasswordRecovery) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/password/recovery`)
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
